module.exports = __webpack_public_path__ + "static/sponsorship_img-05-b@2x-efceb5436b635c76608b3d50e73bd4b6.jpg";